export const zenlessContextKey = Symbol('zenlessContextKey')

export const zenlessSizes = ['extra', 'large', 'small', 'mini']

export const zenlessColors = ['default', 'primary', 'success', 'danger', 'warning', 'info', 'ether', 'fire', 'electric', 'ice', 'physical']